import { render } from "./QuickClientCreate.vue?vue&type=template&id=6b6d3136"
import script from "./QuickClientCreate.vue?vue&type=script&lang=js"
export * from "./QuickClientCreate.vue?vue&type=script&lang=js"

import "./QuickClientCreate.vue?vue&type=style&index=0&id=6b6d3136&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__